import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable, BehaviorSubject, Subject } from 'rxjs'
import { map, catchError, tap, shareReplay } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { LoginService } from './login.service'

@Injectable({
	providedIn: 'root',
})
export class UpdateService {
	private subject = new Subject<string>();
	data$ = this.subject.asObservable();

	gameplan$ =	 new BehaviorSubject<string>('');
	gamePlanData$ = this.gameplan$.asObservable();

	private notificationActiveSubject = new Subject<boolean>();
  	notificationActive$ = this.notificationActiveSubject.asObservable();

	private stopDashboardVideoSource = new Subject<void>();
	stopDashboardVideos$ = this.stopDashboardVideoSource.asObservable();

	forumHeaderData: BehaviorSubject<any> = new BehaviorSubject([]);

	loginStudentData:BehaviorSubject<any> = new BehaviorSubject<any >([]);
	loginDataLoaded:boolean = false;

	private getAppInitiateRequest$:Observable<any>;
	private getStudentData$:Observable<any>;
	private getCurrentGame$:Observable<any>;

	Url = `${environment.apiUrl}`
	constructor(private http: HttpClient, private store:Store, private loginService:LoginService) { }

	stopAllVideos() {
		this.stopDashboardVideoSource.next();
	}

	setNotificationActive(state: boolean) {
    this.notificationActiveSubject.next(state);
  	}

	getStudentDetails() {
		return this.store.select(
			(store: any) => store.student?.student_details
		);
	}

	getStudentData(){
		if(!this.getStudentData$) {
			this.getStudentData$ = this.http.post(this.Url + 'student/details', {mf_token: ""})
			.pipe(
				shareReplay(1)
			)
		} 
		return this.getStudentData$;
	}

	currentGameplan(currentGamePlan) {
		this.gameplan$.next(currentGamePlan);
	}

	/* Using the existing data */
	fetchStudentData() {
		if (this.loginDataLoaded) {
			return this.loginStudentData.asObservable();
		} else {
			return this.http.post(this.Url + 'student/details', {mf_token: ""}).subscribe((data) => {
				this.loginStudentData.next(data);
				this.loginDataLoaded = true;
			});
		}
	}

	fetchStudentDatanew() {
		return this.http.post(this.Url + 'student/details', {mf_token: ""});
	}

	getUpdates(){
		return this.http.get(this.Url + 'get-updates-for-user')
	}

	pinUpdate(params){
		return this.http.post(this.Url + 'pin-update-for-user', params)
	}

	getStudentGameplanStatus(param) {
		if(!this.getCurrentGame$) {
			this.getCurrentGame$ = this.http.post(this.Url + 'gameplan/candGameplanStatus', param).pipe(
				shareReplay(1)
			)
		}
		return this.getCurrentGame$;
	}

	updateData(newData: string): void {
		this.subject.next(newData);
	}


	forumLaunchpadForum(params={}) {
		return this.http.post(this.Url + 'forumLaunchpad', params)
	}

	/* Using the session data */
	forumHeader(params={}) {
		const cached = sessionStorage.getItem('forumLaunchpad');
		if (cached) {
			this.forumHeaderData.next(JSON.parse(cached));
		} else {
			this.http.post(this.Url + 'forumLaunchpad', params).subscribe(res => {
				this.forumHeaderData.next(res);
				sessionStorage.setItem('forumLaunchpad', JSON.stringify(res));
			});
		}
	}

	/* Get the cache from the app request */
	getAppInitiateRequest(param):Observable<any> {
		if(!this.getAppInitiateRequest$) {
			this.getAppInitiateRequest$ = this.http.post<any>(this.Url + 'getAppInitiateRequest', param).pipe(
				shareReplay(1)
			);
		}
		return this.getAppInitiateRequest$
	}

	mobileAppUpdateRequest(param) {
		return this.http.post(this.Url + 'mobileAppUpdateRequest', param)
	}

	getguide(param):Observable<any>{
		// if(!this.getGuide$) {
			return this.http.post<any>(this.Url + 'getguide', param)
			// .pipe(
			// 	shareReplay(1)
			// )
		// }

		// return this.getGuide$;
	}

	addguide(param){
		return this.http.post(this.Url + 'addguide', param)
	}

	updateguide(param){
		return this.http.post(this.Url + 'updateguide', param)
	}
	
	updatelmsstatus(param){
		return this.http.post(this.Url + 'updatelmsstatus', param)
	}
}
